import Vue from 'vue'

import VueCurrencyFilter from 'vue-currency-filter';
Vue.use(VueCurrencyFilter, {
	symbol: 'Kr ',
	thousandsSeparator: ' ',
	fractionCount: 2,
	fractionSeparator: ',',
	symbolPosition: 'front',
	symbolSpacing: false
});

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

export default Vue;
